import { Moment } from 'moment'

import { PreviewSections } from 'Core/interfaces'
import {
	formatValueDescriptionDataToLabelValue,
	formatValueDescriptionDataToLabelValueId
} from 'Core/utils'

import { FormatParameters, parameterTypeValue } from './constants'

export const disableDateForYearRange = (
	currentDate: Moment,
	[firstDate, lastDate]: [Moment | null, Moment | null]
): boolean => {
	if (!firstDate && !lastDate) {
		return false
	}

	const maxDate = firstDate?.clone().add(1, 'year')
	const minDate = lastDate?.clone().subtract(1, 'year')

	const isBeforeMaxDate = !maxDate || currentDate.isBefore(maxDate)
	const isAfterMinDate = !minDate || currentDate.isAfter(minDate)

	const isActiveDate = isAfterMinDate && isBeforeMaxDate

	return !isActiveDate
}

export const formatReportParametersPreviewOptions = (option: ValueDescription[]) => {
	return [
		{
			// will be added in the future improvement
			label: ``,
			options: formatValueDescriptionDataToLabelValueId(option)
		}
	]
}

export const formatParameters = <T extends FormatParameters>(parameter: T[]) => {
	return parameter.map(
		({ parameterType, id, either, or, validationGroup, isRequired, label }) => ({
			either,
			or,
			label,
			validationGroup,
			isRequired,
			value: parameterType.extra ? parameterTypeValue[parameterType.extra] : null,
			fieldName: parameterType.extra,
			id
		})
	)
}

export const getExtraFieldName = (name: string) => {
	const conditions = Object.values(PreviewSections)

	return conditions.find((condition) => name.toLowerCase().includes(condition)) || null
}

export const formatReportParameters = <T extends { parameterType: Entity }[]>(parameter: T) => {
	return parameter.map((parameter) => ({
		...parameter,
		parameterType: {
			...parameter.parameterType,
			extra: getExtraFieldName(parameter.parameterType.name)
		}
	}))
}

export const formatParametersPreviewOptions = (
	option: ValueDescription[],
	parameterName: string
) => {
	return [
		{
			label: `Search by ${parameterName}`,
			options: formatValueDescriptionDataToLabelValue(option)
		}
	]
}
